// extracted by mini-css-extract-plugin
export default {"root":"Theme_root__lEfIH"};